import { useTranslation } from "react-i18next";

import { Badge, BadgeColors } from "@dotnet/telematics-design-system";

import { DeviceModelTaskTypeSupportProps } from "./types";

const DeviceModelTaskTypeSupport = ({
    isSupported,
    titleKey
}: DeviceModelTaskTypeSupportProps) => {
    const { t } = useTranslation();

    return (
        <Badge
            color={isSupported ? BadgeColors.success : BadgeColors.warning}
            inverted
        >
            {t(`${titleKey}##${isSupported}`)}
        </Badge>
    );
};

export default DeviceModelTaskTypeSupport;
